import { type ServiceMethod } from '@/application/interfaces/service';
import { type ErrorResponse as BaseErrorResponse } from '@/infra/services/model';

export type Params = {
  cartId: string;
};

export type Body = {
  override?: boolean;
  products: {
    id: number;
    quantity: number;
    skuId?: string;
  }[];
  type: 'delivery';
};

export type Data = Params & Body;

export type Response = {
  data: {
    shippings: {
      items: {
        id: string;
        productId: number;
        quantity: number;
      }[];
    }[];
    uniqueProductsCount: number;
    id: string;
  };
};

export type ErrorResponse = BaseErrorResponse<
  'stock' | 'item' | 'modality' | 'product'
>;

const addProductsToCart: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { products, override = false, type, cartId } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/carts/{cartId}',
      {
        ...options,
        body: {
          products,
          override,
          type,
        },
        params: {
          cartId,
        },
      }
    );

    return response;
  };

export default addProductsToCart;
